// libraries
import { Badge } from '@interstate/components/Badge';
import { Card } from '@interstate/components/Card';
import { Typography } from '@interstate/components/Typography';

// types
import type { PurchaseHistoryCard } from '@makemydeal/dr-dash-types';

// components
import PurchaseHistoryFieldUI from './PurchaseHistoryFieldUI';

// utils
import { composeRateDisplay, composeTermDisplay } from './purchaseHistoryDisplay';

// styles
import { StyledCardHeadline, StyledFieldRow } from './PurchaseHistorySection.style';

export type PurchaseHistoryCardUIProps = {
    record: PurchaseHistoryCard;
    index: number;
};

export const PurchaseHistoryCardUI = ({ record, index }: PurchaseHistoryCardUIProps) => {
    const { vehicle, vpps, soldDate, dealType, paymentAmount, termMonths, remainingPayments, frontGross, backGross, rate } = record;

    const cardContent = (
        <>
            <StyledCardHeadline>
                <Typography tag="span" variant="strong-sm" color="sem.color.on-surface.default">
                    {vehicle}
                </Typography>
                {vpps.map((vpp, vppIndex) => (
                    <Badge key={vpp} variant="transparent" data-testid={`purchase-history-vpp-${vppIndex}`}>
                        {vpp}
                    </Badge>
                ))}
            </StyledCardHeadline>
            <StyledFieldRow>
                <PurchaseHistoryFieldUI label="Purchase Date" value={soldDate} />
                <PurchaseHistoryFieldUI label="Deal Type" value={dealType} />
                <PurchaseHistoryFieldUI label="Payment" value={paymentAmount} />
                <PurchaseHistoryFieldUI label="Term" value={composeTermDisplay(termMonths, remainingPayments)} />
                <PurchaseHistoryFieldUI label="Front Gross" value={frontGross} />
                <PurchaseHistoryFieldUI label="Back Gross" value={backGross} />
                {/* Null for Cash and an unreported deal type; a lease's money factor sits on the sell side. */}
                {rate && <PurchaseHistoryFieldUI label="Buy/Sell Rate" value={composeRateDisplay(rate)} />}
            </StyledFieldRow>
        </>
    );
    return <Card data-testid={`purchase-history-card-${index}`} padding="1rem" content={cardContent} />;
};

export default PurchaseHistoryCardUI;
